module.exports = __webpack_public_path__ + "img/investor.4c8f8fd.png";